import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DateTime } from 'luxon';
import { RequestResponseHeaderEnum } from '@splitsecondconnect/ultramarine-shared';

export const TimezoneInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const modifiedReq = req.clone({
    headers: req.headers.set(
      RequestResponseHeaderEnum.TIMEZONE,
      DateTime.local().zoneName,
    ),
  });

  return next(modifiedReq);
};
